module.exports = __webpack_public_path__ + "static/img/2en.0d0764c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/2en.png
// module id = HO3R
// module chunks = 0